<template>
  <transition
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear>
    <div class="animated">
      <mainHeader></mainHeader>
      <div class="container" v-if="$route.name !== 'index'">
        <sideNav class="nav"></sideNav>
        <router-view class="view"></router-view>
      </div>
      <router-view class="page" v-else></router-view>
      <mainFooter v-if="$route.name !== 'index'"></mainFooter>
    </div>
  </transition>
</template>

<script>
import mainHeader from "./header.vue";
import mainFooter from "./footer.vue";
import sideNav from "./side-nav.vue";

export default {
  components: {
    mainHeader,
    sideNav,
    mainFooter
  }
};
</script>

<style lang="less" type="text/less">
@import "../assets/less/index";
.container {
  margin: 48px auto;
  width: 90%;
  background-color: #fff;
  box-shadow: 0 4px 30px 0 rgba(223, 225, 230, 0.5);
  .nav {
    float: left;
    width: 200px;
  }
  .view {
    float: left;
    width: calc(~"100% - 205px");
    padding: 32px 48px 48px;
    box-sizing: border-box;
  }
}
.container:after {
  content: "";
  clear: both;
  display: block;
}
</style>



// WEBPACK FOOTER //
// AppMain.vue?2b2ffa30